import { Directive, Input, OnInit, ElementRef, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[gaManager]'
})
export class GaManagerDirective implements AfterViewInit {
  private readonly dataLayer;

  constructor(private elementRef: ElementRef) {
    this.dataLayer = window["dataLayer"];
  }
  @Input('gaManager') tags: any;

  ngAfterViewInit(): void {
    //console.log(this.tags);
    //console.log(this.elementRef.nativeElement);
    if (this.dataLayer !== undefined) {
      if (this.tags.type === 'impression') {
        this.dataLayer.push({
          GA_EventCategory: this.tags["category"] || "",
          GA_EventAction: this.tags["action"] || "",
          GA_EventLabel: this.tags["label"] || "",
          event: 'GTM event To GA'
        });
      }
    }
  }
  @HostListener('click', ['$event']) onClick(event) {
    if (this.dataLayer !== undefined) {
      if (this.tags.type === 'click') {
        //console.log(this.elementRef.nativeElement);
        this.dataLayer.push({
          GA_EventCategory: this.tags["category"] || "",
          GA_EventAction: this.tags["action"] || "",
          GA_EventLabel: this.tags["label"] || "",
          event: 'GTM event To GA'
        });
      }
    }
    //console.log(event);
  }
  @HostListener('window:keydown', ['$event']) keyEvent(event: KeyboardEvent) {
    if (this.dataLayer !== undefined) {
      if (event.key === "Enter") {
        if (this.tags.type === 'click') {
          //console.log(this.elementRef.nativeElement);
          this.dataLayer.push({
            GA_EventCategory: this.tags["category"] || "",
            GA_EventAction: this.tags["action"] || "",
            GA_EventLabel: this.tags["label"] || "",
            event: 'GTM event To GA'
          });
        }
      }
    }
  }
}